export const byDate = 'byDate';
export const byYear = 'byYear';
export const eachMonthOfYear = 'eachMonthOfYear';
export const quarterOfYear = 'quarterOfYear';
export const byMonth = 'month';
export const other = 'other';
